import { getEnvLink } from 'helpers/routes';
// Components
import { showToast } from 'components/common/Toast/Toast';

export const AFFILIATE_LANDING_BASE_PATH = '/a';

export const roundMoney = (value: number): number =>
  Math.round(value * 100) / 100;

/**
 * Commission is a share of the organizer's net (price after the platform fee
 * and promocode), never of the gross price. Mirrors the backend snapshot math.
 */
export const calculateAffiliateCommission = (
  netProfit: number,
  commissionPercent: number
): number => {
  if (!(netProfit > 0) || !(commissionPercent > 0)) {
    return 0;
  }

  return roundMoney((netProfit * commissionPercent) / 100);
};

export const getAffiliateLandingPath = (code: string): string =>
  `${AFFILIATE_LANDING_BASE_PATH}/${code}`;

export const getAffiliateLandingUrl = (code: string): string =>
  `${getEnvLink()}${getAffiliateLandingPath(code)}`;

export const copyAffiliateLink = async (code: string): Promise<void> => {
  try {
    await navigator.clipboard.writeText(getAffiliateLandingUrl(code));
    showToast({ message: 'Affiliate link copied', autoClose: 1000 });
  } catch (error) {
    showToast({ message: 'Could not copy', type: 'error', autoClose: 1000 });
  }
};
